module.exports = __webpack_public_path__ + "static/mummymug-3819dbc9f78bb7897edcd0eaec3b444a.jpeg";